import { css } from '@emotion/react';

import { colors } from '../../../configs';

export const inputContainerStyles = css`
  width: 100%;
`;

export const labelStyles = css`
  text-transform: capitalize;
  font-weight: 500;
  font-size: 14px;
  color: ${colors.BLACK};
`;

export const iconAndInputContainerStyles = css`
  position: relative;
`;

export const iconStyles = css`
  position: absolute;
  top: 50%;
  left: 15px;
  margin: -9px 0 0 0;
  font-size: 18px;
  color: ${colors.LIGHT_BLUE};
`;

export const inputStyles = (label, icon) => css`
  width: 100%;
  height: 40px;
  margin: ${label ? '8px' : 0} 0 0 0;
  padding: ${icon ? '12px 16px 12px 44px' : '12px 16px'};
  border: 1px solid ${colors.GREY};
  border-radius: 8px;
  background-color: ${colors.BACKGROUND_WHITE};
  font-size: 14px;
  color: ${colors.BLACK};
  outline: none;
  -moz-appearance: none;
  -webkit-appearance: none;

  &::placeholder {
    text-transform: capitalize;
    color: ${colors.GREY};
  }

  &:focus {
    border-color: ${colors.LIGHT_BLUE};
  }

  &:read-only {
    background-color: ${colors.GREY};
    cursor: not-allowed;

    &::placeholder {
      color: ${colors.WHITE};
    }
  }
`;
